import { ko } from 'date-fns/locale';
import React from 'react';
import ReactDatePicker from 'react-datepicker';
import CustomTable from '../../../../components/Table';
import { Style } from './style';
import { TotalDeviceProps } from './type';

const TotalDeviceView = ({ hook }: TotalDeviceProps) => {
  const renderHotelTableItem = () => {
    return (
      <>
        {hook.deviceTotal.map((data, dataIndex: number) => (
          <tr className="webTableWrap" key={dataIndex}>
            <td>{data.store_name}</td>
            <td>{Number(data.count)}</td>
            <td>{Number(data.unregistered_room_count)}</td>
            <td>
              {Number(data.normal_count)}{' '}
              <span>({Math.round((Number(data.normal_count) / data.count) * 100)}%)</span>
            </td>
            <td>{Number(data.alltime_count)}</td>
            <td>{Number(data.checkin_count)}</td>
            <td>{Number(data.checkout_count)}</td>
            <td>
              {data.abnormal_count}{' '}
              <span>({Math.round((Number(data.abnormal_count) / data.count) * 100)}%)</span>
            </td>
            <td>{data.over_inactive_count}</td>
          </tr>
        ))}
        <tr style={{ borderTop: '2px solid #ddd' }}>
          <td>합계</td>
          <td>{Number(hook.totals.count)}</td>
          <td>{Number(hook.totals.unregistered_room_count)}</td>

          <td>
            {Number(hook.totals.normal_count)}{' '}
            <span>
              ({Math.round((Number(hook.totals.normal_count) / hook.totals.count) * 100)}%)
            </span>
          </td>
          <td>{Number(hook.totals.alltime_count)}</td>
          <td>{Number(hook.totals.checkin_count)}</td>
          <td>{Number(hook.totals.checkout_count)}</td>
          <td>
            {Number(hook.totals.abnormal_count)}{' '}
            <span>
              ({Math.round((Number(hook.totals.normal_count) / hook.totals.count) * 100)}%)
            </span>
          </td>
          <td>{Number(hook.totals.over_inactive_count)}</td>
        </tr>
      </>
    );
  };

  const CalendarView = () => {
    return (
      <ReactDatePicker
        id={'datePicker'}
        className="datePicker"
        selected={hook.date}
        onChange={(update) => hook.setDate(update!)}
        dateFormat={hook.getDateTitle()}
        locale={ko}
        maxDate={new Date()}
        showMonthYearPicker={hook.dateType === 1}
        onFocus={(e) => {
          e.preventDefault();
          e.target.blur();
        }}
      />
    );
  };

  return (
    <Style>
      <div className="totalDeviceTable">
        <button className="show" onClick={() => hook.setTotalIsOpen(!hook.totalIsOpen)}>
          전체 호텔 통계 확인
        </button>
        {hook.totalIsOpen && (
          <>
            {hook.dataLoading ? (
              <div className="loadingWrap">데이터를 불러오는 중입니다...</div>
            ) : (
              <div className="tableWrap">
                <div className="dateButtonWrap">
                  <div className="flexWrap">
                    <button
                      className={`date ${hook.dateType === 0 && 'active'}`}
                      onClick={() => hook.setDateType(0)}>
                      일별
                    </button>
                    <button
                      className={`date ${hook.dateType === 1 && 'active'}`}
                      onClick={() => hook.setDateType(1)}>
                      월별
                    </button>
                  </div>
                  <button className="excel" onClick={hook.excelDownloadClick}>
                    액셀 다운로드
                  </button>
                </div>
                <CalendarView />
                <CustomTable
                  tableHeader={hook.tableHeader}
                  renderTableItem={renderHotelTableItem}
                  type="border"
                />
              </div>
            )}
          </>
        )}
      </div>
    </Style>
  );
};

export default TotalDeviceView;
